import {Platform, Share, ShareContent, StyleSheet, View, ViewStyle} from "react-native";
import {UserProfile} from "@/lib/types";
import {useLocalSearchParams, useRouter} from "expo-router";
import {dataRetryPolicy, fetchBackend} from "@/lib/backend";
import {useSession} from "@/lib/auth/auth";
import ErrorPage from "@/lib/components/ErrorPage";
import {useQuery} from "@tanstack/react-query";
import SpinnerPage from "@/lib/components/SpinnerPage";
import {useState} from "react";
import Page from "@/lib/components/Page";
import {API_URL, BASE_URL} from "@/lib/constants";
import {SvgUri} from "react-native-svg";
import Center from "@/lib/components/Center";
import Header from "@/lib/components/Header";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import * as Clipboard from 'expo-clipboard';
import {useAccount} from "@/lib/components/AccountProvider";

export default function SharePage() {
    const {username} = useLocalSearchParams();
    const {session} = useSession();
    const [copied, setCopied] = useState(false);
    const router = useRouter();

    const profileQuery = useQuery<UserProfile>({
        queryKey: ['profile', username, session],
        queryFn: () => fetchBackend(`/profile/${username}`, "GET", session),
        retry: dataRetryPolicy,
    })

    const {account, accountError, accountLoading} = useAccount();

    if (profileQuery.error) {
        return <ErrorPage error={profileQuery.error}/>
    } else if (accountError) {
        return <ErrorPage error={accountError}/>
    } else if (profileQuery.isPending || accountLoading || !account) {
        return <SpinnerPage/>
    }

    const profile = profileQuery.data;

    const qrcodeSource = API_URL + `/profile/${username}/qrcode`;
    const selfURL = BASE_URL + `/u/profile/${username}`;
    const metadataStyle: ViewStyle = {
        borderColor: profile.avatar.color,
    };
    const shareData: ShareContent | undefined = (() => {
        if (Platform.OS === "android") {
            return {message: selfURL}
        } else if (Platform.OS === "ios") {
            return {url: selfURL}
        }
    })();

    return (
        <Page>
            <Center width={330} style={{alignItems: "center"}}>
                <SvgUri uri={qrcodeSource} width={330} height={330} style={{maxWidth: "100%"}}/>
                <View style={[styles.metadata, metadataStyle]}>
                    <Header title={"@" + profile.avatar.username}/>
                </View>
                <Nav centered={true}>
                    {(Platform.OS === "ios" || Platform.OS === "android") &&
                        <ActionButton
                            icon={"share"}
                            title={"Del brukerprofil"}
                            onPress={async () => {
                                await Share.share(shareData!);
                                router.dismiss();
                            }}
                        />
                    }
                    {Platform.OS !== "ios" &&
                        <ActionButton
                            icon={"link"}
                            title={(copied ? "Kopiert!" : "Kopier lenke")}
                            disabled={copied}
                            onPress={async () => {
                                await Clipboard.setStringAsync(selfURL);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 1000);
                            }}
                        />
                    }
                </Nav>
            </Center>
        </Page>
    )
}

export const styles = StyleSheet.create({
    metadata: {
        width: "100%",
        flexDirection: "column",
        gap: 8,
        borderWidth: 1,
        borderRadius: 8,
        padding: 12,
    },
})